import * as React from 'react';
import moment from 'moment-timezone';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Store } from './types';
import { USER_NS } from './Constants';

const Footer: React.FC = () => {
    const user = useSelector(({ app }: Store) => app.user);
    const { t } = useTranslation();

    return (
        <div className='app-footer'>
            <div className='user footer-item'>
                {t(`${USER_NS}.logged_user`)}: {user.fullName} ({user.userName})
            </div>
            <div className='version footer-item'>VERSION 0.0.1-2021</div>
            <div className='current-time footer-item'>
                {moment().format('DD-MM-YYYY')}
            </div>
        </div>
    );
};

export default Footer;
